<template>
  <tbody>
  <tr :class="[{'more_info': updatable}, { open: isOpen }]" @click="toggleMoreInfo()">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
          <span
              v-if="!updatable"
              class="lock"
              :title="'Uzamknuto' | translate"
              v-translate>
          </span>
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @change="onChange"
             :checked="isChecked"
             @click.stop
      />
      <label :for="entity.id" @click.stop v-translate>Vybrat</label>
    </td>
    <td class="first_data" data-th="Cena"><strong>{{ entity.formated_value }}</strong></td>
    <td data-th="Business model"><entity-link :id="entity.id_business_model" type="businessModel">{{ entity.business_model_name }}</entity-link></td>
    <td data-th="Operátor"><entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link></td>
    <td data-th="Název měny">{{ entity.currency_name }}</td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_format(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="updatable"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeletePrice">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
  <tr v-if="updatable" :class="['more_info_content', { open: isOpen }]">
    <td></td>
    <td></td>
    <td class="first_data">
      <text-input
          :id="'package-price-value-'+entity.id"
          v-model="entity.value"
          :required="true">
        <translate class="translate">Cena</translate>
      </text-input>
    </td>
    <td></td>
    <td><p>
      <input
          class="btn"
          type="submit"
          :value="'Uložit' | translate"
          @click.stop.prevent="emitUpdatePrice">
    </p></td>
    <td colspan="2"><p></p></td>
    <td class="first_data"><p></p></td>
  </tr>
  </tbody>
</template>

<script>
import EntityLink from "../../../common/EntityLink.vue";
export default {
  name: "PackageRow",
  components: { EntityLink },
  props: {
    entity: Object,
    selectedEntities: Array,
    isDeletable: Boolean,
    idSubscriber: Number,
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  computed: {
    isChecked() {
      return this.selectedEntities.indexOf(String(this.entity.id)) > -1
    },
    updatable() {
      if(this.$_loggedUser_selectedOperatorId){
        return this.$_updateActionAllowed && !this.entity.global && !this.entity.id_business_model;
      }else {
        return this.$_updateActionAllowed && !this.entity.global;
      }
    }
  },
  methods: {
    onChange: function (e) {
      this.$emit('input', e)
    },
    toggleMoreInfo() {
      if (this.$_updateActionAllowed) {
        this.isOpen = !this.isOpen
      }
    },
    emitUpdatePrice() {
      let data = {
        id: this.entity.id,
        id_selected_operator: this.$_loggedUser_selectedOperatorId,
        value: this.entity.value,
      }
      this.$emit('updatePrice', data)
      this.hideMoreInfo()
    },
    emitDeletePrice() {
      this.$emit('deletePrice', String(this.entity.id))
    },
    hideMoreInfo() {
      this.isOpen = false
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/views/vodPackages/detail/PricesRow.vue